import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { NumericPicker } from '@elparking/components'
import useDebounce from 'commons/js/hooks/useDebounce'
const ExtraServiceBoxCurrency = ({
    defaultUnits,
    onChange,
    disabled,
    qtyMax,
    fontSize,
}) => {
    const [units, setUnits] = useState(defaultUnits)
    const debouncedUnits = useDebounce(units, 1000)

    useEffect(() => {
        onChange && onChange(debouncedUnits)
    }, [onChange, debouncedUnits])

    return <NumericPicker fontSize={fontSize} min={0} disabled={disabled} value={units} onChange={setUnits} max={qtyMax}/>
}

ExtraServiceBoxCurrency.propTypes = {
    defaultUnits: PropTypes.number,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    qtyMax: PropTypes.number,
    fontSize: PropTypes.string,
}

export default ExtraServiceBoxCurrency
